import React, { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";

import { dashboardData } from "../../api/request";
import { logo2, soundIcon, closeBtn } from "../../assets/images";
import { AppLink } from "../../common/";

export default function Home() {
  const [model, setModel] = useState(false);

  const [toggleSound, setToggleSound] = useState(
    localStorage.getItem("soundPropCourse")
  );
  const [homeData, setHomeData] = useState({});

  useEffect(() => {
    getDashnoardData();
  }, []);

  const getDashnoardData = async () => {
    const homeResult = await dashboardData();
    if (homeResult?.status) {
      setHomeData(homeResult?.data?.info);
    } else {
      console.log("something went wrong on dashboard");
    }
  };

  const handleChange = (e) => {
    setToggleSound(e.target.checked);
    localStorage.setItem("soundPropCourse", e.target.checked);
  };

  const handlemodelEvent = () => {
    setModel(true);
  };

  return (
    <>
      <Header />
      <section className="middle-part">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="right-logo">
                <img src={logo2} width="100%" alt="logo 2" />
              </div>
              <div className="right-text">{homeData && homeData?.subTitle}</div>
              <div className="right-btn ">
                <div className="btn-1">
                  <AppLink
                    className="btn btn-big"
                    type="button"
                    to="/video-listings/top20/none"
                    onClick={() => {}}
                  >
                    View our Top 20 Micro Courses
                  </AppLink>
                </div>
                <div className="btn-2 ">
                  <AppLink
                    className="btn btn-big"
                    type="button"
                    to="/basicDetails"
                    onClick={() => {}}
                  >
                    Create a Micro-Course
                  </AppLink>
                </div>
                <div className="btn-2">
                  <a
                    className="btn btn-big"
                    type="button"
                    data-bs-toggle="modal"
                    // onClick={audioHandle}
                    data-bs-target="#playModal"
                    // onClick={start}
                  >
                    Site Settings
                  </a>
                </div>
                <div></div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="right-box ">
                <div className="top-hadding">
                  <div className="box-title" id="homePageTextBoardHeading">
                    On Build-a-Course, you can create your own micro-courses on
                    any subject in just a few minutes and then share them with
                    others. These include...
                  </div>
                </div>
                <div className="overflow scroller">
                  <div id="homePageTextBoard">
                    <div className="row_one bounceInLeft">
                      Over 40 courses on Coaching and Learning Skills
                    </div>
                    <div className="row_two bounceInRight">
                      Over 80 courses on Communications
                    </div>
                    <div className="row_one bounceInLeft">
                      Over 60 courses on Conversation Skills
                    </div>
                    <div className="row_two bounceInRight">
                      Over 60 courses on Creative Thinking
                    </div>
                    <div className="row_one bounceInLeft">
                      Over 40 courses on Employee Skills
                    </div>
                    <div className="row_two bounceInRight">
                      Over 50 courses on The Front-Line Leader
                    </div>
                    <div className="row_one bounceInLeft">
                      Over 50 courses on Marketing and Sales
                    </div>
                    <div className="row_two bounceInRight">
                      Over 20 courses on Project Management
                    </div>
                    <div className="row_one bounceInLeft">
                      Over 40 courses on Qualities for Personal Success
                    </div>
                    <div className="row_two bounceInRight">
                      Over 50 courses on Stress Management
                    </div>
                    <div className="row_one bounceInLeft">
                      Over 20 courses on You and Your Career
                    </div>
                    <div className="row_two bounceInRight">
                      ... and many more
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal settings-modal play-modal" id="playModal">
          <div className="modal-dialog">
            <div className="modal-content ">
              <div className="modal-header">
                <h4 className="modal-title">SETTINGS </h4>
                <img
                  data-bs-dismiss="modal"
                  className="btn-close popup-close"
                  src={closeBtn}
                  width="40px"
                  alt="close"
                />
              </div>
              <div className="modal-body modal-inner-box modal-play-box">
                <div className="model-content">
                  <div className="sound-box">
                    <div className="sound-text">
                      <span className="saund-icon">
                        <img src={soundIcon} width="100%" alt="logo 2" />
                      </span>
                      <span className="text">Sound</span>
                    </div>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        id="checkkkd"
                        value={toggleSound}
                        // defaultChecked={toggleSound}
                        onClick={handleChange}
                      />
                      <div className="slider">
                        <div className="on-off-btn"></div>
                      </div>
                    </label>
                  </div>
                  <div className="popup-btn">
                    <a
                      className="btn btn-big"
                      type="button"
                      data-bs-toggle="modal"
                      // onClick={audioHandle}
                      data-bs-target="#settings"
                    >
                      Privacy Policy
                    </a>

                    <a
                      className="btn btn-big"
                      type="button"
                      data-bs-toggle="modal"
                      // onClick={audioHandle}
                      data-bs-target="#settings1"
                    >
                      Terms and Conditions
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal settings-modal" id="settings">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Privacy Policy </h4>
                <img
                  data-bs-dismiss="modal"
                  className="btn-close popup-close"
                  src={closeBtn}
                  width="40px"
                  alt="close"
                />
              </div>
              <div className="modal-body modal-inner-box  scroller">
                <div className="model-content">
                  <p>Last updated: March 12th 2023</p>
                  <p>
                    This Privacy Policy describes Our policies and procedures on
                    the collection, use and disclosure of Your information when
                    You use the Service and tells You about Your privacy rights
                    and how the law protects You.
                  </p>
                  <p>
                    We use Your Personal data to provide and improve the
                    Service. By using the Service, You agree to the collection
                    and use of information in accordance with this Privacy
                    Policy.
                  </p>
                  <p>Interpretation and Definitions</p>
                  <p>Interpretation</p>
                  <p>
                    The words of which the initial letter is capitalized have
                    meanings defined under the following conditions.
                  </p>
                  <p>
                    The following definitions shall have the same meaning
                    regardless of whether they appear in singular or in plural.
                  </p>

                  <p>Definitions</p>
                  <p>For the purposes of this Privacy Policy:</p>
                  <p>
                    Account means a unique account created for You to access our
                    Service or parts of our Service.
                  </p>
                  <p>
                    Company (referred to as either "the Company", "We", "Us" or
                    "Our" in this Agreement) refers to KSA Training Ltd, 113,
                    Main Street, Spittal, Berwick-upon-Tweed, TD15 1RP.
                  </p>
                  <p>
                    Cookies are small files that are placed on Your computer,
                    mobile device or any other device by a website, containing
                    the details of Your browsing history on that website among
                    its many uses.
                  </p>
                  <p>Country refers to:</p>
                  <p>United Kingdom</p>
                  <p>
                    Device means any device that can access the Service such as
                    a computer, a cellphone or a digital tablet.
                  </p>
                  <p>
                    Personal Data is any information that relates to an
                    identified or identifiable individual.
                  </p>
                  <p>Service refers to the Website.</p>
                  <p>
                    Service Provider means any natural or legal person who
                    processes the data on behalf of the Company. It refers to
                    third-party companies or individuals employed by the Company
                    to facilitate the Service, to provide the Service on behalf
                    of the Company, to perform services related to the Service
                    or to assist the Company in analyzing how the Service is
                    used.
                  </p>
                  <p>
                    Usage Data refers to data collected automatically, either
                    generated by the use of the Service or from the Service
                    infrastructure itself (for example, the duration of a page
                    visit).
                  </p>
                  <p>
                    Website refers to Build-a-Course, accessible from
                    http://www.build-a-course.com
                  </p>
                  <p>
                    You means the individual accessing or using the Service, or
                    the company, or other legal entity on behalf of which such
                    individual is accessing or using the Service, as applicable.
                  </p>

                  <p>Collecting and Using Your Personal Data</p>

                  <p>Types of Data Collected</p>

                  <p>Personal Data</p>
                  <p>
                    While using Our Service, We may ask You to provide Us with
                    certain personally identifiable information that can be used
                    to contact or identify You. Personally identifiable
                    information may include, but is not limited to:
                  </p>
                  <p>First name and last name</p>
                  <p>Usage Data</p>

                  <p>Usage Data</p>
                  <p>
                    Usage Data is collected automatically when using the
                    Service.
                  </p>
                  <p>
                    Usage Data may include information such as Your Device's
                    Internet Protocol address (e.g. IP address), browser type,
                    browser version, the pages of our Service that You visit,
                    the time and date of Your visit, the time spent on those
                    pages, unique device identifiers and other diagnostic data.
                  </p>

                  <p>
                    When You access the Service by or through a mobile device,
                    We may collect certain information automatically, including,
                    but not limited to, the type of mobile device You use, Your
                    mobile device unique ID, the IP address of Your mobile
                    device, Your mobile operating system, the type of mobile
                    Internet browser You use, unique device identifiers and
                    other diagnostic data.
                  </p>

                  <p>
                    We may also collect information that Your browser sends
                    whenever You visit our Service or when You access the
                    Service by or through a mobile device.
                  </p>

                  <p>Tracking Technologies and Cookies</p>
                  <p>
                    We use Cookies and similar tracking technologies to track
                    the activity on Our Service and store certain information.
                    Tracking technologies used are beacons, tags, and scripts to
                    collect and track information and to improve and analyze Our
                    Service. The technologies We use may include:
                  </p>

                  <ul>
                    <li>
                      Cookies or Browser Cookies. A cookie is a small file
                      placed on Your Device. You can instruct Your browser to
                      refuse all Cookies or to indicate when a Cookie is being
                      sent. However, if You do not accept Cookies, You may not
                      be able to use some parts of our Service. Unless you have
                      adjusted Your browser setting so that it will refuse
                      Cookies, our Service may use Cookies.
                    </li>
                    <li>
                      Flash Cookies. Certain features of our Service may use
                      local stored objects (or Flash Cookies) to collect and
                      store information about Your preferences or Your activity
                      on our Service. Flash Cookies are not managed by the same
                      browser settings as those used for Browser Cookies. For
                      more information on how You can delete Flash Cookies,
                      please read "Where can I change the settings for
                      disabling, or deleting local shared objects?" available at
                      https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_
                    </li>
                    <li>
                      Web Beacons. Certain sections of our Service and our
                      emails may contain small electronic files known as web
                      beacons (also referred to as clear gifs, pixel tags, and
                      single-pixel gifs) that permit the Company, for example,
                      to count users who have visited those pages or opened an
                      email and for other related website statistics (for
                      example, recording the popularity of a certain section and
                      verifying system and server integrity).
                    </li>
                  </ul>

                  <p>
                    Cookies can be "Persistent" or "Session" Cookies. Persistent
                    Cookies remain on Your personal computer or mobile device
                    when You go offline, while Session Cookies are deleted as
                    soon as You close Your web browser.{" "}
                  </p>

                  <p>
                    We use both Session and Persistent Cookies for the purposes
                    set out below:
                  </p>

                  <p>Necessary / Essential Cookies</p>
                  <p>Type:</p>

                  <p>Session Cookies</p>
                  <p>Administered by: Us</p>
                  <p>
                    Purpose: These Cookies are essential to provide You with
                    services available through the Website and to enable You to
                    use some of its features. They help to authenticate users
                    and prevent fraudulent use of user accounts. Without these
                    Cookies, the services that You have asked for cannot be
                    provided, and We only use these Cookies to provide You with
                    those services.
                  </p>
                  <p>Cookies Policy / Notice Acceptance Cookies</p>
                  <p>Type: Persistent Cookies</p>
                  <p>Administered by: Us</p>
                  <p>
                    Purpose: These Cookies identify if users have accepted the
                    use of cookies on the Website.
                  </p>

                  <p>Functionality Cookies</p>
                  <p>Type: Persistent Cookies</p>
                  <p>Administered by: Us</p>
                  <p>
                    Purpose: These Cookies allow us to remember choices You make
                    when You use the Website, such as remembering your login
                    details or language preference. The purpose of these Cookies
                    is to provide You with a more personal experience and to
                    avoid You having to re-enter your preferences every time You
                    use the Website.
                  </p>

                  <p>
                    For more information about the cookies we use and your
                    choices regarding cookies, please visit our Cookies Policy
                    or the Cookies section of our Privacy Policy.
                  </p>

                  <p>Use of Your Personal Data</p>
                  <p>
                    The Company may use Personal Data for the following
                    purposes:
                  </p>
                  <p>
                    To provide and maintain our Service, including to monitor
                    the usage of our Service.
                  </p>
                  <p>
                    To manage Your Account: to manage Your registration as a
                    user of the Service. The Personal Data You provide can give
                    You access to different functionalities of the Service that
                    are available to You as a registered user.
                  </p>
                  <p>
                    For the performance of a contract: the development,
                    compliance and undertaking of the purchase contract for the
                    products, items or services You have purchased or of any
                    other contract with Us through the Service.
                  </p>
                  <p>
                    To contact You: To contact You by email, telephone calls,
                    SMS, or other equivalent forms of electronic communication,
                    such as a mobile application's push notifications regarding
                    updates or informative communications related to the
                    functionalities, products or contracted services, including
                    the security updates, when necessary or reasonable for their
                    implementation.
                  </p>
                  <p>
                    To provide You with news, special offers and general
                    information about other goods, services and events which we
                    offer that are similar to those that you have already
                    purchased or enquired about unless You have opted not to
                    receive such information.
                  </p>
                  <p>
                    To manage Your requests: To attend and manage Your requests
                    to Us.
                  </p>
                  <p>
                    For business transfers: We may use Your information to
                    evaluate or conduct a merger, divestiture, restructuring,
                    reorganization, dissolution, or other sale or transfer of
                    some or all of Our assets, whether as a going concern or as
                    part of bankruptcy, liquidation, or similar proceeding, in
                    which Personal Data held by Us about our Service users is
                    among the assets transferred.
                  </p>
                  <p>
                    For other purposes: We may use Your information for other
                    purposes, such as data analysis, identifying usage trends,
                    determining the effectiveness of our promotional campaigns
                    and to evaluate and improve our Service, products, services,
                    marketing and your experience.
                  </p>

                  <p>
                    We may share Your personal information in the following
                    situations:
                  </p>
                  <ul>
                    <li>
                      With Service Providers: We may share Your personal
                      information with Service Providers to monitor and analyze
                      the use of our Service, to contact You.
                    </li>
                    <li>
                      For business transfers: We may share or transfer Your
                      personal information in connection with, or during
                      negotiations of, any merger, sale of Company assets,
                      financing, or acquisition of all or a portion of Our
                      business to another company.
                    </li>
                    <li>
                      With Affiliates: We may share Your information with Our
                      affiliates, in which case we will require those affiliates
                      to honor this Privacy Policy. Affiliates include Our
                      parent company and any other subsidiaries, joint venture
                      partners or other companies that We control or that are
                      under common control with Us.
                    </li>
                    <li>
                      With business partners: We may share Your information with
                      Our business partners to offer You certain products,
                      services or promotions.
                    </li>
                    <li>
                      With other users: when You share personal information or
                      otherwise interact in the public areas with other users,
                      such information may be viewed by all users and may be
                      publicly distributed outside.
                    </li>
                    <li>
                      With Your consent: We may disclose Your personal
                      information for any other purpose with Your consent.
                    </li>
                  </ul>

                  <p>Retention of Your Personal Data</p>
                  <p>
                    The Company will retain Your Personal Data only for as long
                    as is necessary for the purposes set out in this Privacy
                    Policy. We will retain and use Your Personal Data to the
                    extent necessary to comply with our legal obligations (for
                    example, if we are required to retain your data to comply
                    with applicable laws), resolve disputes, and enforce our
                    legal agreements and policies.
                  </p>

                  <p>
                    The Company will also retain Usage Data for internal
                    analysis purposes. Usage Data is generally retained for a
                    shorter period of time, except when this data is used to
                    strengthen the security or to improve the functionality of
                    Our Service, or We are legally obligated to retain this data
                    for longer time periods.
                  </p>

                  <p>Transfer of Your Personal Data</p>
                  <p>
                    Your information, including Personal Data, is processed at
                    the Company's operating offices and in any other places
                    where the parties involved in the processing are located. It
                    means that this information may be transferred to — and
                    maintained on — computers located outside of Your state,
                    province, country or other governmental jurisdiction where
                    the data protection laws may differ than those from Your
                    jurisdiction.
                  </p>

                  <p>
                    Your consent to this Privacy Policy followed by Your
                    submission of such information represents Your agreement to
                    that transfer.
                  </p>
                  <p>
                    The Company will take all steps reasonably necessary to
                    ensure that Your data is treated securely and in accordance
                    with this Privacy Policy and no transfer of Your Personal
                    Data will take place to an organization or a country unless
                    there are adequate controls in place including the security
                    of Your data and other personal information.
                  </p>

                  <p>Disclosure of Your Personal Data</p>

                  <p>Business Transactions</p>
                  <p>
                    If the Company is involved in a merger, acquisition or asset
                    sale, Your Personal Data may be transferred. We will provide
                    notice before Your Personal Data is transferred and becomes
                    subject to a different Privacy Policy.
                  </p>

                  <p>Law enforcement</p>
                  <p>
                    Under certain circumstances, the Company may be required to
                    disclose Your Personal Data if required to do so by law or
                    in response to valid requests by public authorities (e.g. a
                    court or a government agency).
                  </p>

                  <p>Other legal requirements</p>
                  <p>
                    The Company may disclose Your Personal Data in the good
                    faith belief that such action is necessary to:
                  </p>

                  <ul>
                    <li>Comply with a legal obligation</li>
                    <li>
                      Protect and defend the rights or property of the Company
                    </li>
                    <li>
                      Prevent or investigate possible wrongdoing in connection
                      with the Service
                    </li>
                    <li>
                      Protect the personal safety of Users of the Service or the
                      public
                    </li>
                    <li>Protect against legal liability</li>
                  </ul>

                  <p>Security of Your Personal Data</p>
                  <p>
                    The security of Your Personal Data is important to Us, but
                    remember that no method of transmission over the Internet,
                    or method of electronic storage is 100% secure. While We
                    strive to use commercially acceptable means to protect Your
                    Personal Data, We cannot guarantee its absolute security.
                  </p>

                  <p>Children's Privacy</p>
                  <p>
                    Our Service does not address anyone under the age of 13. We
                    do not knowingly collect personally identifiable information
                    from anyone under the age of 13. If You are a parent or
                    guardian and You are aware that Your child has provided Us
                    with Personal Data, please contact Us. If We become aware
                    that We have collected Personal Data from anyone under the
                    age of 13 without verification of parental consent, We take
                    steps to remove that information from Our servers.
                  </p>

                  <p>
                    If We need to rely on consent as a legal basis for
                    processing Your information and Your country requires
                    consent from a parent, We may require Your parent's consent
                    before We collect and use that information.
                  </p>

                  <p>Links to Other Websites</p>

                  <p>
                    Our Service may contain links to other websites that are not
                    operated by Us. If You click on a third party link, You will
                    be directed to that third party's site. We strongly advise
                    You to review the Privacy Policy of every site You visit.
                  </p>

                  <p>
                    We have no control over and assume no responsibility for the
                    content, privacy policies or practices of any third party
                    sites or services.
                  </p>

                  <p>Changes to this Privacy Policy</p>
                  <p>
                    We may update Our Privacy Policy from time to time. We will
                    notify You of any changes by posting the new Privacy Policy
                    on this page.
                  </p>

                  <p>
                    We will let You know via email and/or a prominent notice on
                    Our Service, prior to the change becoming effective and
                    update the "Last updated" date at the top of this Privacy
                    Policy.
                  </p>

                  <p>
                    You are advised to review this Privacy Policy periodically
                    for any changes. Changes to this Privacy Policy are
                    effective when they are posted on this page.
                  </p>

                  <p>Contact Us</p>
                  <p>
                    If you have any questions about this Privacy Policy, You can
                    contact us:
                  </p>
                  <ul>
                    <li>By email: slidetopics@gmail.com</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal settings-modal" id="settings1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">TERMS & CONDITIONS</h4>
                <img
                  data-bs-dismiss="modal"
                  className="btn-close popup-close"
                  src={closeBtn}
                  width="40px"
                  alt="close"
                />
              </div>
              <div className="modal-body modal-inner-box  scroller">
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">1</th>
                        <th className="t-two">
                          INTRODUCTION AND GENERAL TERMS
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">1.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          These terms and conditions shall govern your use of
                          our website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">1.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          By using our website, you accept these terms and
                          conditions in full; accordingly, if you disagree with
                          these terms and conditions or any part of these terms
                          and conditions, you must not use our website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">1.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          If you register with our website, submit any material
                          to our website or use any of our website services, we
                          will ask you to expressly agree to these terms and
                          conditions.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">1.4</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You must be at least 18 years of age to use our
                          website; by using our website or agreeing to these
                          terms and conditions, you warrant and represent to us
                          that you are at least 18 years of age.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">2</th>
                        <th className="t-two">Credit</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">2.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          This document was created using a template from
                          Docular
                          (https://seqlegal.com/free-legal-documents/website-terms-and-conditions).
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">3</th>
                        <th className="t-two">Copyright notice</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">3.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Copyright (c) 2023 KSA Training Ltd
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">3.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Subject to the express provisions of these terms and
                          conditions:
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          we, together with our licensors, own and control all
                          the copyright and other intellectual property rights
                          in our website and the material on our website; and
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          all the copyright and other intellectual property
                          rights in our website and the material on our website
                          are reserved.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">4</th>
                        <th className="t-two">Permission to use website</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">4.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">You may:</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          view pages from our website in a web browser;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          download pages from our website for caching in a web
                          browser; download files for your own use as e-learning
                          material;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          print pages from our website for your own personal and
                          non-commercial use, providing that such printing is
                          not systematic or excessive;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(d)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          stream audio and video files from our website using
                          the media player on our website; and
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(e)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          use our website services by means of a web browser,
                          subject to the other provisions of these terms and
                          conditions.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">4.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Except as expressly permitted by Section 4.1 or the
                          other provisions of these terms and conditions, you
                          must not download any material from our website or
                          save any such material to your computer.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">4.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You may only use our website for your own personal and
                          business purposes; you must not use our website for
                          any other purposes.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">4.4</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Except as expressly permitted by these terms and
                          conditions, you must not edit or otherwise modify any
                          material on our website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">4.5</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Unless you own or control the relevant rights in the
                          material, you must not:
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          republish material from our website (including
                          republication on another website);
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          sell, rent or sub-license material from our website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          show any material from our website in public;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(d)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          exploit material from our website for a commercial
                          purpose; or
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(e)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          redistribute material from our website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">4.6</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Notwithstanding Section 4.5, you may redistribute
                          links to our website in print and electronic form to
                          any person.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">4.7</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          We reserve the right to suspend or restrict access to
                          our website, to areas of our website and/or to
                          functionality upon our website. We may, for example,
                          suspend access to the website during server
                          maintenance or when we update the website. You must
                          not circumvent or bypass, or attempt to circumvent or
                          bypass, any access restriction measures on the
                          website.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">5</th>
                        <th className="t-two">Misuse of website</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">5.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">You must not:</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          use our website in any way or take any action that
                          causes, or may cause, damage to the website or
                          impairment of the performance, availability,
                          accessibility, integrity or security of the website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          use our website in any way that is unlawful, illegal,
                          fraudulent or harmful, or in connection with any
                          unlawful, illegal, fraudulent or harmful purpose or
                          activity;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          hack or otherwise tamper with our website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(d)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          probe, scan or test the vulnerability of our website
                          without our permission;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(e)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          circumvent any authentication or security systems or
                          processes on or relating to our website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(f)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          use our website to copy, store, host, transmit, send,
                          use, publish or distribute any material which consists
                          of (or is linked to) any spyware, computer virus,
                          Trojan horse, worm, keystroke logger, rootkit or other
                          malicious computer software;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(g)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          impose an unreasonably large load on our website
                          resources (including bandwidth, storage capacity and
                          processing capacity);
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(h)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          decrypt or decipher any communications sent by or to
                          our website without our permission;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(i)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          conduct any systematic or automated data collection
                          activities (including without limitation scraping,
                          data mining, data extraction and data harvesting) on
                          or in relation to our website without our express
                          written consent;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(j)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          access or otherwise interact with our website using
                          any robot, spider or other automated means, except for
                          the purpose of search engine indexing;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(k)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          use our website except by means of our public
                          interfaces;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(l)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          violate the directives set out in the robots.txt file
                          for our website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(m)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          use data collected from our website for any direct
                          marketing activity (including without limitation email
                          marketing, SMS marketing, telemarketing and direct
                          mailing); or
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(n)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          do anything that interferes with the normal use of our
                          website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">5.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You must not use data collected from our website to
                          contact individuals, companies or other persons or
                          entities.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">5.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You must ensure that all the information you supply to
                          us through our website, or in relation to our website,
                          is true, accurate, current, complete and
                          non-misleading.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">6</th>
                        <th className="t-two">Registration and accounts</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">6.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You may register for an account with our website by
                          completing and submitting the account registration
                          form on our website, and clicking on the verification
                          link in the email that the website will send to you.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">6.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You must not allow any other person to use your
                          account to access the website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">6.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You must notify us in writing immediately if you
                          become aware of any unauthorised use of your account.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">6.4</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You must not use any other person's account to access
                          the website, unless you have that person's express
                          permission to do so.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">7</th>
                        <th className="t-two">User login details</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">7.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          If you register for an account with our website, you
                          will be asked to choose a user ID and password.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">7.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Your user ID must not be liable to mislead and must
                          comply with the content rules set out in Section 10;
                          you must not use your account or user ID for or in
                          connection with the impersonation of any person.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">7.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You must keep your password confidential.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">7.4</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You must notify us in writing immediately if you
                          become aware of any disclosure of your password.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">7.5</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You are responsible for any activity on our website
                          arising out of any failure to keep your password
                          confidential, and may be held liable for any losses
                          arising out of such a failure.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">8</th>
                        <th className="t-two">
                          Cancellation and suspension of account
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">8.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">We may:</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">suspend your account;</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">cancel your account; and/or</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          edit your account details, at any time in our sole
                          discretion with or without notice to you.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">8.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          We will usually cancel an account if it remains unused
                          for a continuous period of 18 months.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">8.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You may cancel your account on our website using your
                          account control panel on the website.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">9</th>
                        <th className="t-two">
                          Our rights to use your content
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">9.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          In these terms and conditions, "your content" means
                          all works and materials (including without limitation
                          text, graphics, images, audio material, video
                          material, audio-visual material, scripts, software and
                          files) that you submit to us or our website for
                          storage or publication on, processing by, or
                          transmission via, our website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">9.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You grant to us a worldwide, irrevocable,
                          non-exclusive, royalty-free licence to use, reproduce,
                          store, adapt, publish, translate and distribute your
                          content in any existing or future media.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">9.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You grant to us the right to sub-license the rights
                          licensed under Section 9.2.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">9.4</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You grant to us the right to bring an action for
                          infringement of the rights licensed under Section 9.2.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">9.5</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You hereby waive all your moral rights in your content
                          to the maximum extent permitted by applicable law; and
                          you warrant and represent that all other moral rights
                          in your content have been waived to the maximum extent
                          permitted by applicable law.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">9.6</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You may edit your content to the extent permitted
                          using the editing functionality made available on our
                          website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">9.7</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Without prejudice to our other rights under these
                          terms and conditions, if you breach any provision of
                          these terms and conditions in any way, or if we
                          reasonably suspect that you have breached these terms
                          and conditions in any way, we may delete, unpublish or
                          edit any or all of your content.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">10</th>
                        <th className="t-two">Rules about your content</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">10.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You warrant and represent that your content will
                          comply with these terms and conditions.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">10.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Your content must not be illegal or unlawful, must not
                          infringe any person's legal rights, and must not be
                          capable of giving rise to legal action against any
                          person (in each case in any jurisdiction and under any
                          applicable law).
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">10.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Your content, and the use of your content by us in
                          accordance with these terms and conditions, must not:
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          be libellous or maliciously false;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">be obscene or indecent;</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          infringe any copyright, moral right, database right,
                          trade mark right, design right, right in passing off
                          or other intellectual property right;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(d)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          infringe any right of confidence, right of privacy or
                          right under data protection legislation;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(e)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          constitute negligent advice or contain any negligent
                          statement;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(f)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          constitute an incitement to commit a crime,
                          instructions for the commission of a crime or the
                          promotion of criminal activity;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(g)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          be in contempt of any court or in breach of any court
                          order;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(h)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          be in breach of racial or religious hatred or
                          discrimination legislation;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(i)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">be blasphemous;</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(j)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          be in breach of official secrets legislation;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(k)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          be in breach of any contractual obligation owed to any
                          person;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(l)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          depict violence in an explicit, graphic or gratuitous
                          manner;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(m)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          be pornographic, lewd, suggestive or sexually
                          explicit;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(n)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          be untrue, false, inaccurate or misleading;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(o)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          consist of or contain any instructions, advice or
                          other information which may be acted upon and could,
                          if acted upon, cause illness, injury or death, or any
                          other loss or damage;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(p)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">constitute spam;</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(q)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          be offensive, deceptive, fraudulent, threatening,
                          abusive, harassing, anti-social, menacing, hateful,
                          discriminatory or inflammatory; or
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(r)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          cause annoyance, inconvenience or needless anxiety to
                          any person.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">11</th>
                        <th className="t-two">Limited warranties</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">11.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">We do not warrant or represent:</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          the completeness or accuracy of the information
                          published on our website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          that the material on the website is up to date;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          that the website will operate without fault; or
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(d)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          that the website or any service on the website will
                          remain available.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">11.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          We reserve the right to discontinue or alter any or
                          all of our website services, and to stop publishing
                          our website, at any time in our sole discretion
                          without notice or explanation; and save to the extent
                          expressly provided otherwise in these terms and
                          conditions, you will not be entitled to any
                          compensation or other payment upon the discontinuance
                          or alteration of any website services, or if we stop
                          publishing the website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">11.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          To the maximum extent permitted by applicable law and
                          subject to Section 12.1, we exclude all
                          representations and warranties relating to the subject
                          matter of these terms and conditions, our website and
                          the use of our website.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">12</th>
                        <th className="t-two">
                          Limitations and exclusions of liability
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">12.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Nothing in these terms and conditions will:
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          limit or exclude any liability for death or personal
                          injury resulting from negligence;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          limit or exclude any liability for fraud or fraudulent
                          misrepresentation;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          {" "}
                          limit any liabilities in any way that is not permitted
                          under applicable law; or
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(d)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          exclude any liabilities that may not be excluded under
                          applicable law.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">12.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          The limitations and exclusions of liability set out in
                          this Section 12 and elsewhere in these terms and
                          conditions:
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">are subject to Section 12.1; and</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          govern all liabilities arising under these terms and
                          conditions or relating to the subject matter of these
                          terms and conditions, including liabilities arising in
                          contract, in tort (including negligence) and for
                          breach of statutory duty, except to the extent
                          expressly provided otherwise in these terms and
                          conditions.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">12.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          To the extent that our website and the information and
                          services on our website are provided free of charge,
                          we will not be liable for any loss or damage of any
                          nature.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">12.4</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          We will not be liable to you in respect of any losses
                          arising out of any event or events beyond our
                          reasonable control.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">12.5</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          {" "}
                          We will not be liable to you in respect of any
                          business losses, including (without limitation) loss
                          of or damage to profits, income, revenue, use,
                          production, anticipated savings, business, contracts,
                          commercial opportunities or goodwill.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">12.6</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          We will not be liable to you in respect of any loss or
                          corruption of any data, database or software.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">12.7</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          We will not be liable to you in respect of any
                          special, indirect or consequential loss or damage.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">12.8</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You accept that we have an interest in limiting the
                          personal liability of our officers and employees and,
                          having regard to that interest, you acknowledge that
                          we are a limited liability entity; you agree that you
                          will not bring any claim personally against our
                          officers or employees in respect of any losses you
                          suffer in connection with the website or these terms
                          and conditions (this will not, of course, limit or
                          exclude the liability of the limited liability entity
                          itself for the acts and omissions of our officers and
                          employees)
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">13</th>
                        <th className="t-two">
                          Breaches of these terms and conditions
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">13.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Without prejudice to our other rights under these
                          terms and conditions, if you breach these terms and
                          conditions in any way, or if we reasonably suspect
                          that you have breached these terms and conditions in
                          any way, we may:
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          send you one or more formal warnings;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          temporarily suspend your access to our website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          permanently prohibit you from accessing our website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(d)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          block computers using your IP address from accessing
                          our website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(e)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          contact any or all of your internet service providers
                          and request that they block your access to our
                          website;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(f)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          commence legal action against you, whether for breach
                          of contract or otherwise; and/or
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(g)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          suspend or delete your account on our website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">13.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Where we suspend or prohibit or block your access to
                          our website or a part of our website, you must not
                          take any action to circumvent such suspension or
                          prohibition or blocking (including without limitation
                          creating and/or using a different account).
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">14</th>
                        <th className="t-two">Variation</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">14.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          We may revise these terms and conditions from time to
                          time.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">14.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          The revised terms and conditions shall apply to the
                          use of our website from the date of publication of the
                          revised terms and conditions on the website, and you
                          hereby waive any right you may otherwise have to be
                          notified of, or to consent to, revisions of these
                          terms and conditions.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">14.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          If you have given your express agreement to these
                          terms and conditions, we will ask for your express
                          agreement to any revision of these terms and
                          conditions; and if you do not give your express
                          agreement to the revised terms and conditions within
                          such period as we may specify, we will disable or
                          delete your account on the website, and you must stop
                          using the website.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">15</th>
                        <th className="t-two">Assignment</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">15.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You hereby agree that we may assign, transfer,
                          sub-contract or otherwise deal with our rights and/or
                          obligations under these terms and conditions.{" "}
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">15.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          You may not without our prior written consent assign,
                          transfer, sub-contract or otherwise deal with any of
                          your rights and/or obligations under these terms and
                          conditions.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">16</th>
                        <th className="t-two">Severability</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">16.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          If a provision of these terms and conditions is
                          determined by any court or other competent authority
                          to be unlawful and/or unenforceable, the other
                          provisions will continue in effect.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">16.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          If any unlawful and/or unenforceable provision of
                          these terms and conditions would be lawful or
                          enforceable if part of it were deleted, that part will
                          be deemed to be deleted, and the rest of the provision
                          will continue in effect.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">17</th>
                        <th className="t-two">Third party rights</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">17.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          A contract under these terms and conditions is for our
                          benefit and your benefit, and is not intended to
                          benefit or be enforceable by any third party.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">17.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          The exercise of the parties' rights under a contract
                          under these terms and conditions is not subject to the
                          consent of any third party.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">18</th>
                        <th className="t-two">Entire agreement</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">18.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Subject to Section 12.1, these terms and conditions,
                          together with our privacy and cookies policy, shall
                          constitute the entire agreement between you and us in
                          relation to your use of our website and shall
                          supersede all previous agreements between you and us
                          in relation to your use of our website.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">19</th>
                        <th className="t-two">Law and jurisdiction</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">19.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          These terms and conditions shall be governed by and
                          construed in accordance with English law.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">19.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Any disputes relating to these terms and conditions
                          shall be subject to the exclusive jurisdiction of the
                          courts of England.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">20</th>
                        <th className="t-two">Our details</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">20.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          This website is owned and operated by KSA Training
                          Ltd.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">20.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          We are registered in England and Wales under
                          registration number 04422466 and our registered office
                          is at Greaves, West & Ayre, 1/3 Sandgate,
                          Berwick-upon-Tweed, Northumberland, TD15 1EW
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">20.3</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Our principal place of business is at 113, Main
                          Street, Spittal, Berwick-upon-Tweed,
                          Berwick-upon-Tweed, Northumberland, TD15 1RP United
                          Kingdom.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">20.4</p>
                      </th>
                      <th className="">
                        <p className="mb-0">You can contact us:</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(a)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          by post, to the postal address given above;
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(b)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">using our website contact form;</p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">(c)</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          by email, using the email address published on our
                          website.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div className="model-title">
                  <table>
                    <tbody>
                      <tr>
                        <th className="t-one">21</th>
                        <th className="t-two">Disclaimer for BiznizBooks</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th className="">
                        <p className="mb-0">21.1</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          Build-a-Course respects the intellectual property
                          rights of others and expects its users to do the same.
                          In accordance with the Digital Millennium Copyright
                          Act of 1998, the text of which may be found on the
                          U.S. Copyright Office website at
                          http://www.copyright.gov/legislation/dmca.pdf, we will
                          respond expeditiously to claims of copyright
                          infringement committed using the Build-a-Course
                          service and/or the Build-a-Course website.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th className="">
                        <p className="mb-0">21.2</p>
                      </th>
                      <th className="">
                        <p className="mb-0">
                          All the information on this website is published in
                          good faith and for general information purpose only.
                          Build-a-Course does not make any warranties about the
                          completeness, reliability and accuracy of this
                          information. Any action you take upon the information
                          you find on this website (www.build-a-course.com), is
                          strictly at your own risk. We will not be liable for
                          any losses and/or damages in connection with the use
                          of the website.
                        </p>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
